module.exports = __webpack_public_path__ + "images/ExternalPromo/adverthorizontal.png?c48a5";